import { MappingType } from 'nextcloud-api';
import { Circle, DefaultFolder } from '../../../services/microsoft/msGraphApi';
import { DefaultFolderModalStep } from '../../reducers/defaultFolder/reducer';
import { createReduxAction, ReduxAction } from '../../utils';
import { DefaultFolderActionType } from './actionTypes';

type SetDefaultFolderPayload = {
    defaultFolder: DefaultFolder;
};

type SetDefaultFolder = ReduxAction<
    DefaultFolderActionType.SetDefaultFolder,
    SetDefaultFolderPayload
>;

export const setDefaultFolder = (
    defaultFolder: DefaultFolder,
): SetDefaultFolder =>
    createReduxAction(DefaultFolderActionType.SetDefaultFolder, {
        defaultFolder,
    });

type SetDefaultFolderModalStepPayload = {
    step: DefaultFolderModalStep;
};

type SetDefaultFolderModalStep = ReduxAction<
    DefaultFolderActionType.SetDefaultFolderModalStep,
    SetDefaultFolderModalStepPayload
>;

export const setDefaultFolderModalStep = (
    step: DefaultFolderModalStep,
): SetDefaultFolderModalStep =>
    createReduxAction(DefaultFolderActionType.SetDefaultFolderModalStep, {
        step,
    });

type SetFormDefaultFolderScopePayload = {
    scope: MappingType;
};

type SetFormDefaultFolderScope = ReduxAction<
    DefaultFolderActionType.SetFormDefaultFolderScope,
    SetFormDefaultFolderScopePayload
>;

export const setFormDefaultFolderScope = (
    scope: MappingType,
): SetFormDefaultFolderScope =>
    createReduxAction(DefaultFolderActionType.SetFormDefaultFolderScope, {
        scope,
    });

type SetFormDefaultFolderCirclesPayload = {
    circle: Circle;
};

type SetFormDefaultFolderCircles = ReduxAction<
    DefaultFolderActionType.SetFormDefaultFolderCircles,
    SetFormDefaultFolderCirclesPayload
>;

export const setFormDefaultFolderCircles = (
    circle: Circle,
): SetFormDefaultFolderCircles =>
    createReduxAction(DefaultFolderActionType.SetFormDefaultFolderCircles, {
        circle,
    });

type SetFormDefaultFolderIdPayload = {
    id: number;
};

type SetFormDefaultFolderId = ReduxAction<
    DefaultFolderActionType.SetFormDefaultFolderId,
    SetFormDefaultFolderIdPayload
>;

export const setFormDefaultFolderId = (id: number): SetFormDefaultFolderId =>
    createReduxAction(DefaultFolderActionType.SetFormDefaultFolderId, {
        id,
    });

type SetFormDefaultFolderPathPayload = {
    path: string;
};

type SetFormDefaultFolderPath = ReduxAction<
    DefaultFolderActionType.SetFormDefaultFolderPath,
    SetFormDefaultFolderPathPayload
>;

export const setFormDefaultFolderPath = (
    path: string,
): SetFormDefaultFolderPath =>
    createReduxAction(DefaultFolderActionType.SetFormDefaultFolderPath, {
        path,
    });
